import createClient from "openapi-fetch";
//#region src/index.ts
/** Type-safe openapi-fetch client generated from the TailSpend OpenAPI spec. */
function createTailSpendClient(options) {
	const { accessToken, headers: initialHeaders, ...clientOptions } = options;
	const headers = {};
	if (initialHeaders instanceof Headers) initialHeaders.forEach((value, key) => {
		headers[key] = value;
	});
	else if (Array.isArray(initialHeaders)) for (const [key, value] of initialHeaders) headers[key] = value;
	else if (initialHeaders) Object.assign(headers, initialHeaders);
	if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
	return createClient({
		...clientOptions,
		headers: Object.keys(headers).length > 0 ? headers : void 0
	});
}
//#endregion
export { createTailSpendClient };

//# sourceMappingURL=index.js.map